import { render } from "./BaseAnchorTag.vue?vue&type=template&id=3fe5260d"
import script from "./BaseAnchorTag.vue?vue&type=script&lang=js"
export * from "./BaseAnchorTag.vue?vue&type=script&lang=js"

import "./BaseAnchorTag.vue?vue&type=style&index=0&id=3fe5260d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__